import { i18n } from "../../../../i18n";

const fb = require('../../../../config/firebase.js')
import { fbFunctions } from "@/config/firebase";

const state = () => ({
    editedUser: {},
    editedUserLoaded: false,
})

const getters = {}

const actions = {
    fetchUserProfile({ commit, state }, payload) {
        fb.usersCollection
            .doc(payload.editedUserId)
            .get()
            .then(function(doc) {
                if (doc.exists) commit('setEditedUserData', doc.data());
                commit('setEditedUserLoaded', true);
            })
            .catch(function(error) {
                console.log("Error getting document:", error);
            });
    },
    updateEditedUserNetworks({ commit, state }) {
        let saveProfileInfos = fbFunctions.httpsCallable('apiAdmin');
        Swal.fire(
            i18n.t("administration.admin.global.modal_save_in_progress_title"),
            i18n.t("administration.admin.global.modal_save_in_progress_content"),
            "warning"
        );
        saveProfileInfos({
            type: 'updateUserNetworks',
            parameters: {
                'userId': state.editedUser.id,
                'networks': {
                    'network_facebook': state.editedUser.networks.network_facebook,
                    'network_twitter': state.editedUser.networks.network_twitter,
                    'network_snapchat': state.editedUser.networks.network_snapchat,
                    'network_instagram': state.editedUser.networks.network_instagram,
                    'network_twitch': state.editedUser.networks.network_twitch,
                    'network_tiktok': state.editedUser.networks.network_tiktok,
                    'network_vimeo': state.editedUser.networks.network_vimeo,
                    'network_youtube': state.editedUser.networks.network_youtube,
                    'network_github': state.editedUser.networks.network_github,
                    'network_linkedin': state.editedUser.networks.network_linkedin,
                    'network_website': state.editedUser.networks.network_website,
                    'network_paypal': state.editedUser.networks.network_paypal,
                    'network_xboxlive': state.editedUser.networks.network_xboxlive,
                    'network_psn': state.editedUser.networks.network_psn,
                    'network_steam': state.editedUser.networks.network_steam,
                    'network_origin': state.editedUser.networks.network_origin,
                    'network_battlenet': state.editedUser.networks.network_battlenet,
                    'network_uplay': state.editedUser.networks.network_uplay,
                    'network_epicgames': state.editedUser.networks.network_epicgames,
                    'network_spotify': state.editedUser.networks.network_spotify,
                    'network_soundcloud': state.editedUser.networks.network_soundcloud,
                    'network_deezer': state.editedUser.networks.network_deezer,
                    'network_applemusic': state.editedUser.networks.network_applemusic,
                    'network_believemusic': state.editedUser.networks.network_believemusic,
                    'network_skype': state.editedUser.networks.network_skype,
                    'network_teams': state.editedUser.networks.network_teams,
                    'network_discord': state.editedUser.networks.network_discord,
                    'network_deviantart': state.editedUser.networks.network_deviantart,
                    'network_pinterest': state.editedUser.networks.network_pinterest,
                    'network_dribbble': state.editedUser.networks.network_dribbble,
                    'network_tipeee': state.editedUser.networks.network_tipeee,
                    'network_patreon': state.editedUser.networks.network_patreon,
                    'network_kickstarter': state.editedUser.networks.network_kickstarter,
                    'network_gofundme': state.editedUser.networks.network_gofundme,
                    'network_leetchi': state.editedUser.networks.network_leetchi,
                    'network_utip': state.editedUser.networks.network_utip,
                    'network_ebay': state.editedUser.networks.network_ebay,
                    'network_leboncoin': state.editedUser.networks.network_leboncoin,
                    'network_vinted': state.editedUser.networks.network_vinted,
                    'network_onlyfans': state.editedUser.networks.network_onlyfans,
                    'network_mym': state.editedUser.networks.network_mym,
                },
            }
        })
        .then(function(result) {
            if(result.data === "SUCCESS_USER_NETWORKS_UPDATE") {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_success_title"),
                    i18n.t("administration.admin.global.modal_save_success_content"),
                    "success"
                )
            } else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_error_title"),
                    i18n.t("administration.admin.global.modal_save_error_content"),
                    "error"
                )
            }
        })
        .catch((e) => {
            swal.fire(
                i18n.t("administration.admin.global.modal_save_error_title"),
                i18n.t("administration.admin.global.modal_save_error_content"),
                "error"
            )
        });
    },
    updateEditedUserInformations({ commit, state }) {
        let saveProfileInfos = fbFunctions.httpsCallable('apiAdmin');
        Swal.fire(
            i18n.t("administration.admin.global.modal_save_in_progress_title"),
            i18n.t("administration.admin.global.modal_save_in_progress_content"),
            "warning"
        );
        saveProfileInfos({
            type: 'updateUserInformations',
            parameters: {
                'userId': state.editedUser.id,
                'nickname': state.editedUser.nickname,
                'hashtags': {
                    'number1': state.editedUser.hashtags['number1'],
                    'number2': state.editedUser.hashtags['number2'],
                    'number3': state.editedUser.hashtags['number3']
                },
                'notifications_preferences': {
                    'notifications_for_like': state.editedUser.notifications_preferences.notifications_for_like,
                    'notifications_for_visit_nfc': state.editedUser.notifications_preferences.notifications_for_visit_nfc,
                    'notifications_for_visit_qrcode': state.editedUser.notifications_preferences.notifications_for_visit_qrcode,
                    'notifications_for_visit_url': state.editedUser.notifications_preferences.notifications_for_visit_url,
                    'notifications_for_visit_search': state.editedUser.notifications_preferences.notifications_for_visit_search,
                    'notifications_for_referral': state.editedUser.notifications_preferences.notifications_for_referral,
                },
                'about': state.editedUser.about,
                'isThemeDark': state.editedUser.preferences['preferences_dark_theme_enabled'],
                'isEmailPublic': state.editedUser.preferences['preferences_display_publicly_email'],
                'isIntroDone': state.editedUser.is_intro_done,
                'phone': state.editedUser.phone
            }
        })
        .then(function(result) {
            if(result.data === "SUCCESS_USER_INFORMATIONS_UPDATE") {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_success_title"),
                    i18n.t("administration.admin.global.modal_save_success_content"),
                    "success"
                )
            } else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_error_title"),
                    i18n.t("administration.admin.global.modal_save_error_content"),
                    "error"
                )
            }
        })
        .catch((e) => {
            swal.fire(
                i18n.t("administration.admin.global.modal_save_error_title"),
                i18n.t("administration.admin.global.modal_save_error_content"),
                "error"
            )
        });
    },
    resetUserAvatarAndCover({ commit, state }) {
        let saveProfileInfos = fbFunctions.httpsCallable('apiAdmin');
        Swal.fire(
            i18n.t("administration.admin.global.modal_save_in_progress_title"),
            i18n.t("administration.admin.global.modal_save_in_progress_content"),
            "warning"
        );
        saveProfileInfos({
            type: 'resetUserAvatarAndCover',
            parameters: {
                'userId': state.editedUser.id,
            }
        })
        .then(function(result) {
            if(result.data === "SUCCESS_USER_AVATAR_AND_COVER_RESET") {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_success_title"),
                    i18n.t("administration.admin.global.modal_save_success_content"),
                    "success"
                )
            } else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_error_title"),
                    i18n.t("administration.admin.global.modal_save_error_content"),
                    "error"
                )
            }
        })
        .catch((e) => {
            swal.fire(
                i18n.t("administration.admin.global.modal_save_error_title"),
                i18n.t("administration.admin.global.modal_save_error_content"),
                "error"
            )
        });
    },
    userBanOrUnban({ commit, state }) {
        let vm = this;
        let saveProfileInfos = fbFunctions.httpsCallable('apiAdmin');
        Swal.fire(
            i18n.t("administration.admin.global.modal_save_in_progress_title"),
            i18n.t("administration.admin.global.modal_save_in_progress_content"),
            "warning"
        );
        saveProfileInfos({
            type: 'userBanOrUnban',
            parameters: {
                'userId': state.editedUser.id,
            }
        })
        .then(function(result) {
            if(result.data === "SUCCESS_ACCOUNT_BANNED") {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_success_title"),
                    i18n.t("administration.admin.global.modal_save_success_content"),
                    "success"
                );
                vm.dispatch('adminAppEditUser/fetchUserProfile', {
                    'editedUserId': state.editedUser.id
                });
            }
            else if(result.data === "SUCCESS_ACCOUNT_UNBANNED") {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_success_title"),
                    i18n.t("administration.admin.global.modal_save_success_content"),
                    "success"
                );
                vm.dispatch('adminAppEditUser/fetchUserProfile', {
                    'editedUserId': state.editedUser.id
                });
            }
            else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_error_title"),
                    i18n.t("administration.admin.global.modal_save_error_content"),
                    "error"
                )
            }
        })
        .catch((e) => {
            swal.fire(
                i18n.t("administration.admin.global.modal_save_error_title"),
                i18n.t("administration.admin.global.modal_save_error_content"),
                "error"
            )
        });
    },
    resetUserInformations({ commit, state }) {
        let vm = this;
        let saveProfileInfos = fbFunctions.httpsCallable('apiAdmin');
        Swal.fire(
            i18n.t("administration.admin.global.modal_save_in_progress_title"),
            i18n.t("administration.admin.global.modal_save_in_progress_content"),
            "warning"
        );
        saveProfileInfos({
            type: 'resetUserInformations',
            parameters: {
                'userId': state.editedUser.id,
            }
        })
        .then(function(result) {
            if(result.data === "SUCCESS_USER_INFORMATIONS_RESET") {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_success_title"),
                    i18n.t("administration.admin.global.modal_save_success_content"),
                    "success"
                );
                vm.dispatch('adminAppEditUser/fetchUserProfile', {
                    'editedUserId': state.editedUser.id
                });
            }
            else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_error_title"),
                    i18n.t("administration.admin.global.modal_save_error_content"),
                    "error"
                )
            }
        })
        .catch((e) => {
            console.log(e);
            swal.fire(
                i18n.t("administration.admin.global.modal_save_error_title"),
                i18n.t("administration.admin.global.modal_save_error_content"),
                "error"
            )
        });
    },
    retrieveUserEmail({ commit, state }) {
        let saveProfileInfos = fbFunctions.httpsCallable('apiAdmin');
        Swal.fire(
            i18n.t("administration.admin.app_edit_user.modal_fetch_in_progress_title"),
            i18n.t("administration.admin.app_edit_user.modal_fetch_in_progress_content"),
            "warning"
        );
        saveProfileInfos({
            type: 'retrieveUserEmail',
            parameters: {
                'userId': state.editedUser.id,
            }
        })
        .then(function(result) {
            if(result.data.code === "SUCCESS_USER_EMAIL_RETRIEVED") {
                swal.fire(
                    i18n.t("administration.admin.app_edit_user.modal_fetch_email_success_title"),
                    i18n.t("administration.admin.app_edit_user.modal_fetch_email_success_content", { email: result.data.email }),
                    "success"
                )
            }
            else {
                swal.fire(
                    i18n.t("administration.admin.global.modal_generic_error_title"),
                    i18n.t("administration.admin.global.modal_generic_error_content"),
                    "error"
                )
            }
        })
        .catch((e) => {
            swal.fire(
                i18n.t("administration.admin.global.modal_generic_error_title"),
                i18n.t("administration.admin.global.modal_generic_error_content"),
                "error"
            )
        });
    },
}

const mutations = {
    setEditedUserData(state, val) {
        state.editedUser = val;
    },
    setEditedUserField(state, val) {
        state.editedUser[val.fieldToEdit] = val.fieldToEditValue;
    },
    setEditedUserHashtags(state, val) {
        state.editedUser.hashtags[val.hashtagToEdit] = val.hashtagToEditValue;
    },
    setEditedUserNetworks(state, val) {
        state.editedUser.networks[val.networkToEdit] = val.networkToEditValue;
    },
    setEditedUserNotificationsPreferences(state, val) {
        state.editedUser.notifications_preferences[val.notificationPreferenceToEdit] = val.notificationPreferenceToEditValue;
    },
    setEditedUserPreferences(state, val) {
        state.editedUser.preferences[val.fieldToEdit] = val.fieldToEditValue;
    },
    setEditedUserLoaded(state, val) {
        state.editedUserLoaded = val;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/stores/modules/pages/admin/appEditUser.js